var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-100"},[_c('b-col',[_c('b-form-group',{attrs:{"label":_vm.label,"label-class":"overflowed_label"}},[_c('b-form-input',{attrs:{"readonly":"","value":_vm.modelValue}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }